var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedChk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05B80FBE-4172-4073-9D59-AF2BA5A5EA7F@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEA7-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mais-web-1",
    transform: "translate(-898.000000, -321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "to-check",
    transform: "translate(874.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox/Selected",
    transform: "translate(24.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    fill: "currentColor",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7128166,8.3175 L11.4478166,15.6175 C11.1303166,16.06 10.4728166,16.06 10.1553166,15.6175 L7.03781663,11.2975 C6.94281663,11.165 7.03781663,10.98 7.20031663,10.98 L8.37281663,10.98 C8.62781663,10.98 8.87031663,11.1025 9.02031663,11.3125 L10.8003166,13.7825 L14.7303166,8.3325 C14.8803166,8.125 15.1203166,8 15.3778166,8 L16.5503166,8 C16.7128166,8 16.8078166,8.185 16.7128166,8.3175 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedChk);
export default __webpack_public_path__ + "static/media/selectedChk.bfaff77a4392628b534e09a06b1e9660.svg";
export { ForwardRef as ReactComponent };